import {ReactNode} from "react";
import {AdminHeader} from "../../components/admin-header";

type AdminLayoutProps = {
    children: ReactNode;
};

export function AdminLayout({children}: AdminLayoutProps) {
    return (
        <div>
            <div className="ambient-light-bg">
                <div className="light-orb orb-1"></div>
                <div className="light-orb orb-2"></div>
                <div className="light-orb orb-3"></div>
            </div>
            <div className="relative min-h-screen flex flex-col">
                <AdminHeader />
                <main className="flex-grow flex flex-col items-center pt-8 pb-20 px-4 sm:px-6">
                    {children}
                </main>
            </div>
        </div>
    )
}

